import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { GenericFormState } from './types';
import { RootState } from '@/vuex/types';

export const state: GenericFormState = {
    currentStepIdx: 1,
    stepsNumber: 1,
    eventId: 1,
    eventTypeId: 1,
    formFlowId: 1,
    formStateId: 1,
    formStateName: 'New',
    formFlows: [],
    formStates: [],
    currentFormState: {
        Id: 1,
        FormFlowId: 1,
        Name: 'New',
        Label: 'New',
        StepNumber: '1',
        IsActive: true,
        IsVisible: true,
    },
    formFields: [],
};

const namespaced = true;

export const form: Module<GenericFormState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
